// extracted by mini-css-extract-plugin
module.exports =  {"card":"a867bdd7c0--card--WigBz","phone":"a867bdd7c0--phone--tzixY","tablet":"a867bdd7c0--tablet--Sqh8b","text":"a867bdd7c0--text--rWi6V","image":"a867bdd7c0--image--ZkLBH"};